import {Icon} from "@iconify/react";
import {Link} from "@tanstack/react-router";

import {useWindowScroll} from "@uidotdev/usehooks";

import React from "react";
import {scrollToTop} from "../utilities/utilities.ts";
import logo_footer_nobg from "./assets/logo_footer_nobg.png";

const SectionFooter = ({className = ""}) => {
    const [scroll] = useWindowScroll();

    return (
        <section className={"Section Section_Footer" + ' ' + className}>
            {/*<div className="SectionHeading">
                <h2>Subscribe to the newsletter</h2>
                <p>Subscribe to our newsletter for tips, updates, and exclusive features to keep your club thriving.</p>
            </div>

            <div className="SectionInner text-center mb-16">
                <form method="post">
                    <input type="email" className="w-[360px] max-md:w-full max-md:mb-4" placeholder="your@email.com" />

                    <input type="submit" value="Submit" className={'bg-[#58ED54] text-[1.1rem] text-black rounded-full ml-3 border-0 px-16 py-3 leading-6 hover:underline'} />
                </form>
            </div>*/}

            <div className="bg-white mb-6 py-6 text-center">
                <img src={logo_footer_nobg} alt="ScorePal logo" className="max-h-24 inline-block" />
            </div>

            <div className="SectionInner">
                <hr />
                <div className="FooterMenu text-[#949494] flex justify-between pt-1 pb-4">
                    <div className={"flex max-sm:flex-col *:px-2 *:py-4 *:min-w-14 *:inline-block *:text-center"}>
                        <Link onClick={() => scrollToTop()} to="/privacy/" className="hover:underline">Privacy Policy</Link>
                        <Link onClick={() => scrollToTop()} to="/cookie-policy/" className="hover:underline">Cookie Policy</Link>
                        <Link onClick={() => scrollToTop()} to="/terms/" className="hover:underline">Terms</Link>
                        <Link onClick={() => scrollToTop()} to="/disclaimer/" className="hover:underline">Disclaimer</Link>
                    </div>
                    <div className="text-right flex max-sm:flex-col *:mx-2 *:py-4 *:min-w-14 *:text-center">
                        <Link onClick={() => scrollToTop()} to="/pricing/" className="hover:underline">Pricing</Link>
                        <Link onClick={() => scrollToTop()} to="/contact/" className="hover:underline">Contact</Link>
                        <Link onClick={() => scrollToTop()} to="/about/" className="hover:underline">About</Link>
                    </div>
                </div>
            </div>
            <a href="#"
               onClick={(e) => {
                   e.preventDefault();
                   scrollToTop('smooth');
               }}
               className={"transition-opacity text-primary rounded-full fixed right-6 bottom-24 shadow-2xl " + ((scroll.y || 0) > 500 ? 'opacity-1' : 'opacity-0 pointer-events-none')}>
                <Icon icon={"material-symbols-light:arrow-circle-up"} className={"text-6xl"} />
            </a>
        </section>
    );
};

export default SectionFooter;
